import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Model } from "appworks/model/model";
import { Services } from "appworks/services/services";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { Parallel } from "appworks/utils/contracts/parallel";
import { LoadSpinCommand } from "slotworks/commands/comms/load-spin-command";
import { StartSpinCommand } from "slotworks/commands/comms/start-spin-command";
import { FooterComponent } from "slotworks/components/footer/footer-component";
import { JurisdictionComponent } from "slotworks/components/jurisdiction/jurisdiction-component";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { ReelSpinner } from "slotworks/components/matrix/reel/transition-behaviours/spin/reel-spinner";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export interface RequestSpinConfig {
    winningsResetDelay: number;
}

export class RequestSpin extends State {

    protected config: RequestSpinConfig = {
        winningsResetDelay: 0
    };

    private skipping: boolean;

    constructor(config?: Partial<RequestSpinConfig>) {
        super();

        if (config) {
            this.config = { ...this.config, ...config };
        }
    }

    public onEnter(cascadeSkip?: boolean) {
        this.skipping = cascadeSkip;

        if (this.skipping || !Services.jurisdiction.getSpinSkippingEnabled()) {
            uiFlags.set(UIFlag.NO_SKIP, true);
        }

        this.newGame();

        ReelSpinner.disableMinSpinTime = false;

        uiFlags.set(UIFlag.IDLE, false);
        uiFlags.set(UIFlag.GAME_IN_PROGRESS, true);
        uiFlags.set(UIFlag.AWAITING_RESPONSE, true);
        uiFlags.closeMenus();

        Components.get(FooterComponent)?.showSpinStart(Services.bet.getTotalStake());
        Components.get(JurisdictionComponent)?.startSpin();

        this.startSpinning().then(() => {
            if (!gameState.getCurrentGame().getCurrentRecord()) {
                this.error();
            } else {
                if (this.skipping) {
                    this.skip();
                } else {
                    this.complete();
                }
                if (gameState.getCurrentGame().getCurrentRecord() instanceof SpinRecord && !uiFlags.has(UIFlag.FREE_BETS)) {
                    Services.jurisdiction.betStaked(Services.bet.getTotalStake());
                }
            }
        });
    }

    public error() {
        Components.get(AbstractMatrixComponent).reset();
        Services.autoplay.stop();
        // TODO: V3: Fix hold spin
        // HoldSpinControl.cancel();
        Model.write({ settings: { turboSpin: false } });

        uiFlags.set(UIFlag.GAME_IN_PROGRESS, false);
        uiFlags.set(UIFlag.NO_SKIP, false);

        super.error();
    }

    public onSkip() {
        uiFlags.set(UIFlag.NO_SKIP, true);
        this.skipping = true;
    }

    public onExit() {
        uiFlags.set(UIFlag.AWAITING_RESPONSE, false);
    }

    protected newGame() {
        gameState.newGame(Services.bet.getTotalStake());

        Services.transaction.setDelayedWinnings(0, 0, this.config.winningsResetDelay).execute();
    }

    protected startSpinning(): Contract<any> {
        return new Parallel([
            () => StartSpinCommand(),
            () => LoadSpinCommand()
        ]);
    }
}
